import React, {FunctionComponent, useState} from "react";
import {RouteProps} from "react-router-dom";
import {useIntl} from "react-intl";
import Layout from "../components/layout/Layout";
import ActivityList from "components/molecules/list/ActivityList";
import CommonEntityHeader from "../components/molecules/header/CommonEntityHeader";
import useSearchFilter from "../hooks/useSearchFilter";
import {ActivitySearchObject} from "../interfaces/ActivityInterfaces";
import Panel from "../components/molecules/panel/Panel";
import CreateActivityForm from "../components/molecules/form/CreateActivityForm";
import {WorkflowStatesEnum} from "../constants/workflow/WorkflowStates";
import useLoading from "../hooks/useLoading";

const ActivityListView: FunctionComponent<RouteProps> = () => {
  const intl = useIntl();
  const {searchObject, onReset, updateSearchField} = useSearchFilter<ActivitySearchObject>({
    name: "",
    reference: "",
    serviceId: "",
    tourId: "",
    status: WorkflowStatesEnum.ACTIVE
  })
  const [lateralPanelActivityOpen, setLateralPanelActivityOpen] = useState<boolean>(false)
  const {loading, stopLoading, startLoading} = useLoading()

  return (
    <Layout>
      <div className="epow-content-body d-flex flex-column">
        <CommonEntityHeader
          fieldState="status"
          pageTitle={intl.formatMessage({id: "activity_title"})}
          updateSearchField={updateSearchField}
          setCreationPanelOpen={setLateralPanelActivityOpen}
          creationButtonLabel={intl.formatMessage({id: "create_new_activity"})}
        />

        <ActivityList
          searchObject={searchObject}
          onReset={() => onReset({currentState: searchObject.currentState, status: searchObject.status})}
          updateSearchField={updateSearchField}
        />

        {lateralPanelActivityOpen && (
          <Panel
            formId="createActivityForm"
            title="create_new_activity"
            open={lateralPanelActivityOpen}
            loading={loading}
            onCancel={() => setLateralPanelActivityOpen(false)}
          >
            <CreateActivityForm id="createActivityForm" startLoading={startLoading} stopLoading={stopLoading}/>
          </Panel>
        )}
      </div>
    </Layout>
  )
}

export default ActivityListView
